import { UrlConstants } from "../url.constants";
export class ApiStampsConstants {
    static URL = UrlConstants.API_V2 + "Stamp";
    static FUNCTION_DELETE_MULTIPLE_STAMPS = "DeleteMultipleStamps";
    static FUNCTION_DELETE_ALL_STAMPS = "DeleteAllStamps";
    static FUNCTION_GET_STAMP_ATTACHMENTS = "GetStampAttachment";
    static FUNCTION_UPLOAD_STAMP_ATTACHMENTS = "UploadStampAttachment";
    static FUNCTION_GET_STAMP_CONTENT_BASE64 = "GetStampContentBase64";
    static FUNCTION_DELETE_STAMP_ATTACHMENT = "DeleteStampAttachment";
}
